var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-8" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Type")]),
          _c("span", [_vm._v(_vm._s(_vm.value.assetType))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Direction")]),
          _c("span", [_vm._v(_vm._s(_vm.value.direction))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Status")]),
          _c("span", [_vm._v(_vm._s(_vm.value.status))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Date")]),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$filters.formatDateTimeLocale(
                  _vm.value.sentOn,
                  _vm.$userInfo.locale
                )
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Contact")]),
          _c("span", [_vm._v(_vm._s(_vm.value.sendTo))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Quote No.")]),
          _c("span", [_vm._v(_vm._s(_vm.value.quoteNoRef))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Claim No.")]),
          _c("span", [_vm._v(_vm._s(_vm.value.claimNo))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Rego")]),
          _c("span", [_vm._v(_vm._s(_vm.value.rego))]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Message")]),
          _c("span", { staticStyle: { "white-space": "pre-wrap" } }, [
            _vm._v(_vm._s(_vm.$filters.replaceBr(_vm.value.message))),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }